export const api_url = "https://www.farmaciasdrvertiz.com/api/api/"
// export const api_url = "http://localhost:8000/api/"
